<template>
  <md-app md-mode="fixed">
    <md-app-toolbar class="md-toolbar" md-elevation="0">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">CircleHR</h3>
          <md-tabs class="md-transparent" md-elevation="0" md-active-tab="messaging-tab">
            <md-tab id="handbook-tab" md-label="Handbook" />
            <md-tab id="messaging-tab" md-label="Messaging" />
            <md-tab id="team-tab" md-label="Team" v-if="user && user.admin" />
          </md-tabs>
        </div>
        <div class="md-toolbar-section-end">
          <md-menu md-align-trigger>
            <md-avatar v-if="user && user.avatar" md-menu-trigger>
              <img :src="user.avatar" alt="People" />
            </md-avatar>
            <md-menu-content>
              <Profile :user="user" />
            </md-menu-content>
          </md-menu>
        </div>
      </div>
    </md-app-toolbar>
    <md-app-content class="my-app">
      <router-view />
    </md-app-content>
  </md-app>
</template>
<script>
import { mapState } from "vuex";
import Profile from "@/components/Profile.vue";
export default {
  name: "Layout",
  components: {
    Profile
  },
  data() {
    return {
      menuVisible: false
    };
  },
  methods: {
    teamUrl: () => (location = process.env.VUE_APP_TEAM_URI)
  },
  computed: {
    ...mapState({
      user: s => s.auth.user
    })
  }
};
</script>
<style lang="scss">
.md-avatar {
  margin-right: 0;
}
.md-app {
  min-height: 100%;
}
.my-app {
  padding: 0px;
}
</style>
